module.exports = __webpack_public_path__ + "6985f122ba56299184d93bbe83be5c42.svg";